import React, { useState } from "react";
import moment, { unix } from "moment";
import PopOver from "./PopOver";
import EditorNew from "../Editor/EditorNew";
import { NavLink } from "react-router-dom";

const ChatDetailsCommon = (props) => {
  const {
    closeModalHandler,
    transcriptId,
    chatDetail,
    getFormattedDate,
    highlightSelection,
    handleMouseUp,
    displayIcon,
    chatIndex,
    userUUID,
    applyColor,
    userList,
    getChatNotes,
    setDisplayIcon,
    updateChat,
    chatContent,
    addChatNote,
    noteAdd,
    chatNotes,
    infoEdit,
    editBtnHandler,
    chatInformation,
    featureName,
    podName,
    prodName,
    getEditForm,
    newchatHistory,
    removeColor,
    activeTab,
    editId,
    noteError,
    noteAdding,
  } = props;

  const [isCopied, setIsCopied] = useState(false);
  const [isNoteCopied, setIsNoteCopied] = useState(false);

  const shareLink = () => {
    console.log("link - ", window.location);
    navigator.clipboard.writeText(`${window.location.href}/${transcriptId}`);
    setIsCopied(true);
    setTimeout(() => {
      setIsCopied(false);
    }, 800);
  };

  const copyLink = (id) => {
    navigator.clipboard.writeText(
      `${window.location.origin}/chat/${transcriptId}#noteId${id}`
    );
    setIsNoteCopied(true);
    setTimeout(() => {
      setIsNoteCopied(false);
    }, 800);
  };

  return (
    <React.Fragment>
      {props.showModal && (
        <div class={`full-chat-area `}>
          <div class="closechat" onClick={closeModalHandler}>
            <div>
              <NavLink to={`/chat/${transcriptId}`}>
                {" "}
                <i class="fa fa-solid fa-expand"></i>{" "}
              </NavLink>
            </div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="feather feather-x"
            >
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </div>

          <div class="row margin-lr-0">
            <div class="col-md-12 chat-padding-0">
              <div class="chat-middle">
                <ul class="nav nav-tabs" role="tablist" id="myTab">
                  <li class={activeTab == 1 ? "chatli active" : "chatli"}>
                    <a
                      href="#chat"
                      role="tab"
                      data-toggle="tab"
                      aria-expanded={activeTab == 1 ? "true" : "false"}
                    >
                      Chat (ID: {transcriptId})
                    </a>
                  </li>
                  <li class={activeTab == 2 ? "chatli active" : "chatli"}>
                    <a
                      href="#notes"
                      role="tab"
                      data-toggle="tab"
                      aria-expanded={activeTab == 2 ? "true" : "false"}
                    >
                      Notes
                    </a>
                  </li>
                  <li class={activeTab == 3 ? "chatli active" : "chatli"}>
                    <a
                      href="#information"
                      role="tab"
                      data-toggle="tab"
                      aria-expanded={activeTab == 3 ? "true" : "false"}
                    >
                      Information
                    </a>
                  </li>
                </ul>
                {/* <div class="chat_id">Chat ID - {transcriptId}</div> */}
                <div class="tab-content">
                  <div class="tab-pane active" id="chat">
                    <div class="topbar">
                      <div class="leftone">
                        <div class="f-Name">
                          {chatDetail && chatDetail.name}
                        </div>
                        <div class="f-desc">
                          <span class="gmail">
                            {(chatDetail && chatDetail.email) || "-NA-"}{" "}
                          </span>
                          <span class="devide">|</span>
                          <span class="time">{getFormattedDate()}</span>
                        </div>
                        {/* <div class="f-desc">Chat ID: {transcriptId}</div> */}
                      </div>
                      <div class="rightone">
                        <div class="inner-rightone" id="innerRightone">
                          {isCopied ? <span>Link Copied</span> : ""}
                          <div class="svg mssg-search" onClick={shareLink}>
                            <i class="fa fa-link"></i>
                          </div>
                        </div>
                        <div
                          class="collapse-search"
                          id="collapseSearch"
                          style={{ display: "none" }}
                        >
                          <input
                            type="search"
                            class="mssg-input"
                            placeholder="Search Here"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="midle-full-chatbox">
                      {console.log("new chat history-", newchatHistory.length)}
                      {Object.keys(chatDetail).length == "" ? (
                        <div class="loader-new"></div>
                      ) : newchatHistory.length > 0 ? (
                        newchatHistory.map((item) => {
                          if (
                            item.hasOwnProperty("type") &&
                            item.type === "chat.memberjoin"
                          ) {
                            return (
                              <p className="text-center">
                                {item.name} has Joined
                              </p>
                            );
                          }

                          if (
                            item.hasOwnProperty("type") &&
                            item.type === "chat.memberleave"
                          ) {
                            return (
                              <p className="text-center">
                                {item.name} has Leave
                              </p>
                            );
                          }

                          if (
                            item.hasOwnProperty("type") &&
                            item.type === "chat.changeemail"
                          ) {
                            return (
                              <p className="text-center">
                                Email Changed to {item.new_email}
                              </p>
                            );
                          }

                          if (
                            item.hasOwnProperty("type") &&
                            item.type === "chat.changename"
                          ) {
                            return (
                              <p className="text-center">
                                Name Changed to {item.newname}
                              </p>
                            );
                          }

                          if (
                            item.hasOwnProperty("type") &&
                            item.type === "chat.rating"
                          ) {
                            return (
                              <p className="text-center">
                                Chat Rating - {item.new_rating}
                              </p>
                            );
                          }

                          if (item.sender_type === "Visitor") {
                            return (
                              <div class="single-recieve">
                                <div class="img-box">
                                  <img src="./image/2.png" />
                                </div>
                                <div
                                  class="mssg-dec"
                                  ref={(el) =>
                                    (props.refff.current[item.index] = el)
                                  }
                                >
                                  <p>
                                    {item.name}{" "}
                                    <span>
                                      {moment(item.timestamp).format("LTS")}
                                    </span>
                                  </p>
                                  <div
                                    class="mssg-text"
                                    onMouseUp={(e) => {
                                      highlightSelection(e, item.index);
                                      handleMouseUp(e);
                                    }}
                                  >
                                    {item.hasOwnProperty("message") ? (
                                      <span
                                        dangerouslySetInnerHTML={{
                                          __html: item.message,
                                        }}
                                      ></span>
                                    ) : (
                                      item.msg
                                    )}
                                  </div>
                                  {console.log(" display ", displayIcon)}
                                  {displayIcon && item.index == chatIndex ? (
                                    <PopOver
                                      obj={{
                                        transcriptId,
                                        chatIndex,
                                        userUUID,
                                        applyColor,
                                        userList,
                                        getChatNotes,
                                        setDisplayIcon,
                                        updateChat,
                                        chatContent,
                                        removeColor,
                                      }}
                                    />
                                  ) : (
                                    ""
                                  )}
                                </div>
                              </div>
                            );
                          } else {
                            return (
                              <div class="single-sender">
                                <div
                                  class="mssg-dec"
                                  ref={(el) =>
                                    (props.refff.current[item.index] = el)
                                  }
                                >
                                  <p>
                                    {item.name}{" "}
                                    <span>
                                      {moment(item.timestamp).format("LTS")}
                                    </span>
                                  </p>
                                  <div
                                    class="mssg-text"
                                    onMouseUp={(e) => {
                                      highlightSelection(e, item.index);
                                      handleMouseUp(e);
                                    }}
                                  >
                                    {item.hasOwnProperty("message") ? (
                                      <span
                                        dangerouslySetInnerHTML={{
                                          __html: item.message,
                                        }}
                                      ></span>
                                    ) : (
                                      item.msg
                                    )}
                                  </div>

                                  {displayIcon && item.index == chatIndex ? (
                                    <PopOver
                                      obj={{
                                        transcriptId,
                                        chatIndex,
                                        userUUID,
                                        applyColor,
                                        userList,
                                        getChatNotes,
                                        setDisplayIcon,
                                        updateChat,
                                        chatContent,
                                        removeColor,
                                      }}
                                    />
                                  ) : (
                                    ""
                                  )}
                                </div>
                                <div class="img-box">
                                  <img src="./image/3.png" />
                                </div>
                              </div>
                            );
                          }
                        })
                      ) : (
                        <div className="text-center">
                          <svg
                            width="56"
                            height="56"
                            viewBox="0 0 56 56"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g clip-path="url(#clip0_504_30600)">
                              <path
                                d="M48.5215 39.9595C48.959 40.7456 49.8374 41.1301 50.738 41.125C52.2693 41.1182 53.4963 42.4221 53.3647 43.979C53.2485 45.3582 52.0044 46.375 50.6201 46.375H42V47.25H6.12498C4.62791 47.25 3.42479 45.9973 3.5034 44.4849C3.5786 43.0647 4.85179 42 6.27366 42H6.99998C8.06297 42 8.90379 41.0532 8.72606 39.9561C8.58592 39.0964 7.77757 38.5 6.90599 38.5H2.62498C1.12791 38.5 -0.0752122 37.2473 0.00340108 35.7349C0.0785966 34.3147 1.35179 33.25 2.77366 33.25H8.31248C9.52073 33.25 10.5 32.2708 10.5 31.0625C10.5 29.8542 9.52073 28.875 8.31248 28.875C7.10423 28.875 6.12498 27.8958 6.12498 26.6875C6.12498 25.4792 7.10423 24.5 8.31248 24.5H15.75V18.375H9.18748C7.44261 18.375 6.03612 16.9138 6.13011 15.1484C6.21556 13.4924 7.70237 12.25 9.36009 12.25H15.75V8.75H49.4375C51.1824 8.75 52.5888 10.2112 52.4949 11.9766C52.4094 13.6326 50.9226 14.875 49.2649 14.875H46.8125C45.0676 14.875 43.6611 16.3362 43.7551 18.1016C43.8406 19.7576 45.3274 21 46.9851 21H49C50.5552 21 51.7942 22.3535 51.6062 23.9446C51.449 25.2656 50.2527 26.1953 48.9248 26.2517C47.8772 26.2944 47.0688 27.26 47.2842 28.3555C47.4499 29.186 48.2326 29.75 49.0786 29.75H52.9375C54.6824 29.75 56.0888 31.2112 55.9949 32.9766C55.9094 34.6326 54.4226 35.875 52.7649 35.875H50.75C48.8325 35.875 47.3952 37.9309 48.5215 39.9595ZM2.18748 28.875C3.39573 28.875 4.37498 27.8958 4.37498 26.6875C4.37498 25.4792 3.39573 24.5 2.18748 24.5C0.979231 24.5 -1.6893e-05 25.4792 -1.6893e-05 26.6875C-1.6893e-05 27.8958 0.979231 28.875 2.18748 28.875ZM2.18748 28.875C3.39573 28.875 4.37498 27.8958 4.37498 26.6875C4.37498 25.4792 3.39573 24.5 2.18748 24.5C0.979231 24.5 -1.6893e-05 25.4792 -1.6893e-05 26.6875C-1.6893e-05 27.8958 0.979231 28.875 2.18748 28.875Z"
                                fill="#EFF6FE"
                              ></path>
                              <path
                                d="M12.8 49V7H34.7516L45.2 17.4484V49H12.8Z"
                                fill="white"
                              ></path>
                              <path
                                d="M33.6747 7.60002C34.2052 7.60002 34.7139 7.81074 35.0889 8.18581L44.0142 17.111C44.3892 17.4861 44.6 17.9948 44.6 18.5253V46.4C44.6 47.5046 43.7045 48.4 42.6 48.4H15.4C14.2954 48.4 13.4 47.5046 13.4 46.4V9.60002C13.4 8.49545 14.2954 7.60002 15.4 7.60002H33.6747ZM35.5857 6.98581C35.2107 6.61074 34.702 6.40002 34.1715 6.40002H14.2C13.0954 6.40002 12.2 7.29545 12.2 8.40002V47.6C12.2 48.7046 13.0954 49.6 14.2 49.6H43.8C44.9045 49.6 45.8 48.7046 45.8 47.6V18.0285C45.8 17.498 45.5892 16.9893 45.2142 16.6142L35.5857 6.98581Z"
                                fill="#E2EAF3"
                              ></path>
                              <path
                                d="M34.4 17.8V7H34.7516L45.2 17.4484V17.8H34.4Z"
                                fill="white"
                              ></path>
                              <path
                                d="M35 8.09682L44.1032 17.2H37C35.8955 17.2 35 16.3046 35 15.2V8.09682ZM35 6.40002H33.8V16.4C33.8 17.5046 34.6955 18.4 35.8 18.4H45.8V17.2L35 6.40002Z"
                                fill="#E2EAF3"
                              ></path>
                              <path
                                d="M32.6 29.4028L29 32.8L34.4648 38.8H38.6V35.2L32.6 29.4028Z"
                                fill="#7AADF0"
                              ></path>
                              <path
                                d="M36.2 22C35.5635 22 34.9531 22.2529 34.503 22.7029C34.0529 23.153 33.8 23.7635 33.8 24.4C33.8 25.0365 34.0529 25.647 34.503 26.0971C34.9531 26.5471 35.5635 26.8 36.2 26.8C36.8365 26.8 37.447 26.5471 37.8971 26.0971C38.3472 25.647 38.6 25.0365 38.6 24.4C38.6 23.7635 38.3472 23.153 37.8971 22.7029C37.447 22.2529 36.8365 22 36.2 22ZM36.2 38.8H19.4V34L25.4 28L36.2 38.8Z"
                                fill="#B5DEFF"
                              ></path>
                            </g>
                            <defs>
                              <clipPath id="clip0_504_30600">
                                <rect
                                  width="56"
                                  height="56"
                                  fill="white"
                                ></rect>
                              </clipPath>
                            </defs>
                          </svg>
                          <div class="mt-3">No Data found</div>
                        </div>
                      )}
                    </div>
                  </div>
                  <div class="tab-pane" id="notes">
                    <div class="note-viewarea">
                      <h3>Add Notes</h3>
                      {console.log("note error", noteError)}
                      {noteError ? (
                        <label className="note-error-msg">
                          Please fill the field*
                        </label>
                      ) : (
                        ""
                      )}
                      <form class="form-area">
                        <EditorNew
                          getEditorData={addChatNote}
                          noteAdd={noteAdd}
                          show_toolbar={true}
                          field_name="chat_note"
                          edit_id={editId}
                          noteAdding={noteAdding}
                        />
                      </form>
                      <div class="note-content-area">
                        {chatNotes.data &&
                          chatNotes.data.map((item) => {
                            return (
                              <div class="single-content">
                                <div class="noimg-box">
                                  <img
                                    src={
                                      userList[item.user_uuid] &&
                                      userList[item.user_uuid].profile_pic
                                    }
                                  />
                                </div>
                                <div class="item-area">
                                  <div class="title-area">
                                    <h5>
                                      <a
                                        href={
                                          userList[item.user_uuid] &&
                                          userList[item.user_uuid].profile_url
                                        }
                                      >
                                        {userList[item.user_uuid] &&
                                          userList[item.user_uuid].name}
                                      </a>
                                    </h5>
                                    {/* <div class="editNote" title="Upload you file" data-toggle="modal" data-target="#edit-note">
                                                                    <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                        <path d="M10.7974 1.36955C10.9725 1.19445 11.1803 1.05556 11.4091 0.960795C11.6379 0.866034 11.8831 0.817261 12.1307 0.817261C12.3783 0.817261 12.6235 0.866034 12.8523 0.960795C13.0811 1.05556 13.2889 1.19445 13.464 1.36955C13.6391 1.54464 13.778 1.75251 13.8728 1.98128C13.9675 2.21006 14.0163 2.45526 14.0163 2.70288C14.0163 2.9505 13.9675 3.1957 13.8728 3.42447C13.778 3.65325 13.6391 3.86112 13.464 4.03621L4.46403 13.0362L0.797363 14.0362L1.79736 10.3695L10.7974 1.36955Z" stroke="#666666" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round"></path>
                                                                    </svg>
                                                                </div> */}
                                  </div>
                                  <div class="snote">
                                    Note{" "}
                                    <a
                                      target="_blank"
                                      href={`chat/${transcriptId}#noteId${item.custom_note_uuid}`}
                                    >
                                      {item.custom_note_uuid}
                                    </a>{" "}
                                    |{" "}
                                    {moment(
                                      unix(item.created_timestamp)
                                    ).format("D  MMM YYYY, h:mm:ss a")}{" "}
                                  </div>

                                  <div class="text-area">
                                    {item.highlight_text ? (
                                      <blockquote
                                        class="quote-card"
                                        dangerouslySetInnerHTML={{
                                          __html: item.highlight_text,
                                        }}
                                      ></blockquote>
                                    ) : (
                                      ""
                                    )}
                                    <div
                                      dangerouslySetInnerHTML={{
                                        __html: item.note_content,
                                      }}
                                    ></div>
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                      </div>
                    </div>
                  </div>
                  <div class="tab-pane" id="information">
                    <div class="col-md-12 chat-padding-0">
                      <div class="chat-right">
                        <div class="tab-content">
                          {!infoEdit ? (
                            <div class="information-viewarea">
                              <div class="infoBtn">
                                <button
                                  class="informDone"
                                  onClick={() => editBtnHandler()}
                                >
                                  <span>
                                    <i
                                      class="fa fa-pencil-square-o"
                                      aria-hidden="true"
                                    ></i>
                                  </span>
                                  Edit
                                </button>
                              </div>

                              {/* <div class="input-box text-right">
                                                            <button class="save-btn" onClick={() => editBtnHandler()}>Edit</button>
                                                        </div> */}
                              <div class="input-box">
                                <label class="input-label">Feature</label>
                                <div class="bunch-span">
                                  {chatInformation &&
                                  chatInformation.feature &&
                                  chatInformation.feature.length
                                    ? chatInformation.feature
                                        .map((feat) => {
                                          return featureName.filter(
                                            (item) => item.id == feat
                                          );
                                        })
                                        .map((ii) => {
                                          return ii.map((io) => (
                                            <span>{io.value}</span>
                                          ));
                                        })
                                    : "-NA-"}
                                </div>
                              </div>
                              <div class="input-box">
                                <label class="input-label">Pod</label>
                                <div class="bunch-span">
                                  {chatInformation &&
                                  chatInformation.pod &&
                                  chatInformation.pod.length
                                    ? chatInformation.pod
                                        .map((pd) => {
                                          return podName.filter(
                                            (item) => item.id == pd
                                          );
                                        })
                                        .map((ii) => {
                                          return ii.map((io) => (
                                            <span>{io.value}</span>
                                          ));
                                        })
                                    : "-NA-"}
                                </div>
                              </div>
                              <div class="input-box">
                                <label class="input-label">Product</label>
                                <div class="bunch-span">
                                  {chatInformation &&
                                  chatInformation.product &&
                                  chatInformation.product.length
                                    ? chatInformation.product
                                        .map((prod) => {
                                          return prodName.filter(
                                            (item) => item.id == prod
                                          );
                                        })
                                        .map((ii) => {
                                          return ii.map((io) => (
                                            <span>{io.value}</span>
                                          ));
                                        })
                                    : "-NA-"}
                                </div>
                              </div>
                              <div class="input-box">
                                <label class="input-label">
                                  Market Feedback
                                </label>
                                <p>
                                  {chatInformation &&
                                    chatInformation.market_feedback &&
                                    chatInformation.market_feedback.map(
                                      (e, i) => {
                                        return (
                                          <a
                                            href={`https://tattle.allthingsott.com/tattle/market-feedback/${e}`}
                                            target="_blank"
                                          >
                                            {e}
                                            {i !==
                                            chatInformation.market_feedback
                                              .length -
                                              1
                                              ? `, `
                                              : ""}
                                          </a>
                                        );
                                      }
                                    )}
                                </p>
                              </div>
                              <div class="input-box">
                                <label class="input-label">Summary</label>
                                <p>{chatInformation.preview}</p>
                              </div>
                              <div class="input-box">
                                <label class="input-label">Email ID</label>
                                <p>
                                  {(chatInformation && chatInformation.email) ||
                                    "-NA-"}
                                </p>
                              </div>
                              <div class="input-box">
                                <label class="input-label">Lead Name</label>
                                <p>
                                  {(chatInformation && chatInformation.name) ||
                                    "-NA-"}
                                </p>
                              </div>
                              <div class="input-box">
                                <label class="input-label">IP Address</label>
                                <p>
                                  {(chatInformation &&
                                    chatInformation.session &&
                                    chatInformation.session.ip) ||
                                    "-NA-"}
                                </p>
                              </div>
                              <div class="input-box">
                                <label class="input-label">Location</label>
                                <p>
                                  {(chatInformation &&
                                    chatInformation.session &&
                                    chatInformation.session.country_name) ||
                                    "-NA-"}
                                </p>
                              </div>
                            </div>
                          ) : (
                            getEditForm()
                          )}
                          <div class="tab-pane" id="note">
                            <div class="note-viewarea">
                              <h3>Add Notes</h3>
                              <form>
                                <textarea
                                  placeholder="Write here"
                                  class="form-control textarea-cls"
                                ></textarea>
                                <div class="editor-icon">
                                  <div class="leftside">
                                    <span class="border-right">
                                      <svg
                                        width="18"
                                        height="19"
                                        viewBox="0 0 18 19"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          d="M11.2151 9.6764C11.6384 9.49152 11.9974 9.18523 12.2466 8.79629C12.4958 8.40736 12.624 7.95324 12.6151 7.4914V7.4614C12.6221 7.16023 12.5677 6.86079 12.4551 6.58139C12.3424 6.30198 12.174 6.04848 11.9601 5.8364C11.2531 5.22013 10.3308 4.9091 9.39507 4.9714H5.89507C5.77862 4.96594 5.66229 4.98434 5.55322 5.02549C5.44414 5.06664 5.34464 5.12965 5.26082 5.21067C5.17699 5.29168 5.11062 5.38898 5.06578 5.49659C5.02094 5.6042 4.99858 5.71983 5.00007 5.8364V13.9064C4.99873 14.021 5.02032 14.1348 5.06356 14.2409C5.10681 14.3471 5.17084 14.4435 5.2519 14.5246C5.33295 14.6056 5.4294 14.6697 5.53556 14.7129C5.64171 14.7562 5.75545 14.7777 5.87007 14.7764H9.53507C11.7201 14.7764 13.1601 13.8364 13.1601 12.0864V12.0564C13.1601 10.7264 12.3651 10.0664 11.2151 9.6764ZM6.84007 6.6064H9.11007C10.1101 6.6064 10.6851 7.0514 10.6851 7.7714V7.8014C10.6851 8.6414 10.0051 9.0464 8.99507 9.0464H6.84007V6.6064ZM11.1851 11.9064C11.1851 12.7014 10.5301 13.1214 9.45507 13.1214H6.84007V10.7164H9.34007C10.5851 10.7164 11.1851 11.1564 11.1851 11.9014V11.9064Z"
                                          fill="#666666"
                                        ></path>
                                      </svg>
                                    </span>
                                    <span class="border-right">
                                      <svg
                                        width="16"
                                        height="17"
                                        viewBox="0 0 16 17"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          d="M11.8242 5.30636H10.1202L7.88018 12.5064H9.57618L9.08018 14.1064H3.68018L4.17618 12.5064H5.88818L8.12818 5.30636H6.42418L6.92018 3.70636H12.3202L11.8242 5.30636Z"
                                          fill="#666666"
                                        ></path>
                                      </svg>
                                    </span>
                                    <span>
                                      <svg
                                        width="18"
                                        height="19"
                                        viewBox="0 0 18 19"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          d="M13.0502 4.0564H11.2502V9.1954C11.2502 10.9864 10.2422 11.8774 9.0452 11.8774C7.8572 11.8774 6.7502 10.9774 6.7502 9.2134V4.0564H4.9502V9.3394C4.9502 11.0584 5.85019 13.4254 8.98219 13.4254C12.1232 13.4254 13.0502 11.1034 13.0502 9.3754V4.0564ZM13.0502 15.7564V13.9564H4.9502V15.7564H13.0502Z"
                                          fill="#666666"
                                        ></path>
                                      </svg>
                                    </span>
                                  </div>
                                  <div class="middleside">
                                    <span class="border-right">
                                      <svg
                                        width="17"
                                        height="17"
                                        viewBox="0 0 17 17"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <g clip-path="url(#clip0_126_8531)">
                                          <path
                                            fill-rule="evenodd"
                                            clip-rule="evenodd"
                                            d="M6.46108 13.6921C6.46108 13.5405 6.52128 13.3952 6.62844 13.288C6.73561 13.1809 6.88095 13.1207 7.03251 13.1207H17.3182C17.4698 13.1207 17.6151 13.1809 17.7223 13.288C17.8294 13.3952 17.8896 13.5405 17.8896 13.6921C17.8896 13.8436 17.8294 13.989 17.7223 14.0961C17.6151 14.2033 17.4698 14.2635 17.3182 14.2635H7.03251C6.88095 14.2635 6.73561 14.2033 6.62844 14.0961C6.52128 13.989 6.46108 13.8436 6.46108 13.6921ZM6.46108 9.12066C6.46108 8.96911 6.52128 8.82376 6.62844 8.7166C6.73561 8.60943 6.88095 8.54923 7.03251 8.54923H17.3182C17.4698 8.54923 17.6151 8.60943 17.7223 8.7166C17.8294 8.82376 17.8896 8.96911 17.8896 9.12066C17.8896 9.27221 17.8294 9.41756 17.7223 9.52472C17.6151 9.63188 17.4698 9.69209 17.3182 9.69209H7.03251C6.88095 9.69209 6.73561 9.63188 6.62844 9.52472C6.52128 9.41756 6.46108 9.27221 6.46108 9.12066ZM6.46108 4.54923C6.46108 4.39768 6.52128 4.25233 6.62844 4.14517C6.73561 4.038 6.88095 3.9778 7.03251 3.9778H17.3182C17.4698 3.9778 17.6151 4.038 17.7223 4.14517C17.8294 4.25233 17.8896 4.39768 17.8896 4.54923C17.8896 4.70078 17.8294 4.84613 17.7223 4.95329C17.6151 5.06045 17.4698 5.12066 17.3182 5.12066H7.03251C6.88095 5.12066 6.73561 5.06045 6.62844 4.95329C6.52128 4.84613 6.46108 4.70078 6.46108 4.54923ZM3.03251 5.69209C3.33561 5.69209 3.6263 5.57168 3.84063 5.35735C4.05496 5.14302 4.17536 4.85233 4.17536 4.54923C4.17536 4.24612 4.05496 3.95543 3.84063 3.74111C3.6263 3.52678 3.33561 3.40637 3.03251 3.40637C2.7294 3.40637 2.43871 3.52678 2.22438 3.74111C2.01006 3.95543 1.88965 4.24612 1.88965 4.54923C1.88965 4.85233 2.01006 5.14302 2.22438 5.35735C2.43871 5.57168 2.7294 5.69209 3.03251 5.69209ZM3.03251 10.2635C3.33561 10.2635 3.6263 10.1431 3.84063 9.92878C4.05496 9.71445 4.17536 9.42376 4.17536 9.12066C4.17536 8.81755 4.05496 8.52686 3.84063 8.31254C3.6263 8.09821 3.33561 7.9778 3.03251 7.9778C2.7294 7.9778 2.43871 8.09821 2.22438 8.31254C2.01006 8.52686 1.88965 8.81755 1.88965 9.12066C1.88965 9.42376 2.01006 9.71445 2.22438 9.92878C2.43871 10.1431 2.7294 10.2635 3.03251 10.2635ZM3.03251 14.8349C3.33561 14.8349 3.6263 14.7145 3.84063 14.5002C4.05496 14.2859 4.17536 13.9952 4.17536 13.6921C4.17536 13.389 4.05496 13.0983 3.84063 12.884C3.6263 12.6696 3.33561 12.5492 3.03251 12.5492C2.7294 12.5492 2.43871 12.6696 2.22438 12.884C2.01006 13.0983 1.88965 13.389 1.88965 13.6921C1.88965 13.9952 2.01006 14.2859 2.22438 14.5002C2.43871 14.7145 2.7294 14.8349 3.03251 14.8349Z"
                                            fill="#666666"
                                          ></path>
                                        </g>
                                        <defs>
                                          <clipPath id="clip0_126_8531">
                                            <rect
                                              width="16"
                                              height="16"
                                              fill="white"
                                              transform="translate(0.889648 0.906372)"
                                            ></rect>
                                          </clipPath>
                                        </defs>
                                      </svg>
                                    </span>
                                    <span>
                                      <svg
                                        width="18"
                                        height="18"
                                        viewBox="0 0 18 18"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          d="M2.20971 12.2331V11.7294H2.51465C2.74521 11.7294 2.90034 11.5839 2.90034 11.3926C2.90034 11.1961 2.73246 11.0633 2.51677 11.0633C2.27984 11.0633 2.12684 11.2248 2.12046 11.3926H1.49359C1.51059 10.8964 1.8899 10.5564 2.54121 10.5564C3.16596 10.5543 3.55484 10.8656 3.55802 11.3034C3.56004 11.4535 3.50854 11.5995 3.41276 11.7151C3.31698 11.8308 3.18316 11.9085 3.03527 11.9345V11.9696C3.20295 11.9821 3.35935 12.0587 3.47194 12.1836C3.58454 12.3085 3.64468 12.4719 3.63984 12.64C3.64302 13.2063 3.10646 13.49 2.52315 13.49C1.82615 13.49 1.46065 13.0969 1.45215 12.6464H2.07052C2.07902 12.8355 2.26815 12.9715 2.5189 12.9747C2.78877 12.9747 2.9694 12.8206 2.96727 12.6028C2.96515 12.3956 2.80259 12.2331 2.5274 12.2331H2.20865H2.20971ZM2.20546 7.24038H1.56371V7.2032C1.56371 6.7697 1.87715 6.30645 2.58159 6.30645C3.20102 6.30645 3.60159 6.65282 3.60159 7.1097C3.60159 7.52301 3.32852 7.76526 3.09584 8.0107L2.52527 8.61845V8.65032H3.64515V9.18901H1.60409V8.76932L2.6209 7.71745C2.76752 7.56657 2.93221 7.39445 2.93221 7.1777C2.93221 6.98645 2.77602 6.8377 2.56884 6.8377C2.52101 6.83594 2.47332 6.844 2.42872 6.86137C2.38412 6.87874 2.34355 6.90506 2.30951 6.9387C2.27547 6.97235 2.24867 7.01261 2.23078 7.057C2.21288 7.10139 2.20427 7.14897 2.20546 7.19682V7.24038ZM3.1139 4.93901H2.43921V2.73326H2.40627L1.7709 3.17951V2.57707L2.43921 2.10638H3.1139V4.93901Z"
                                          fill="#666666"
                                        ></path>
                                        <path
                                          fill-rule="evenodd"
                                          clip-rule="evenodd"
                                          d="M5.70215 12.6251C5.70215 12.4842 5.75812 12.3491 5.85775 12.2495C5.95738 12.1498 6.0925 12.0939 6.2334 12.0939H15.7959C15.9368 12.0939 16.0719 12.1498 16.1715 12.2495C16.2712 12.3491 16.3271 12.4842 16.3271 12.6251C16.3271 12.766 16.2712 12.9011 16.1715 13.0008C16.0719 13.1004 15.9368 13.1564 15.7959 13.1564H6.2334C6.0925 13.1564 5.95738 13.1004 5.85775 13.0008C5.75812 12.9011 5.70215 12.766 5.70215 12.6251ZM5.70215 8.37512C5.70215 8.23423 5.75812 8.0991 5.85775 7.99947C5.95738 7.89984 6.0925 7.84387 6.2334 7.84387H15.7959C15.9368 7.84387 16.0719 7.89984 16.1715 7.99947C16.2712 8.0991 16.3271 8.23423 16.3271 8.37512C16.3271 8.51602 16.2712 8.65114 16.1715 8.75077C16.0719 8.8504 15.9368 8.90637 15.7959 8.90637H6.2334C6.0925 8.90637 5.95738 8.8504 5.85775 8.75077C5.75812 8.65114 5.70215 8.51602 5.70215 8.37512ZM5.70215 4.12512C5.70215 3.98423 5.75812 3.8491 5.85775 3.74947C5.95738 3.64984 6.0925 3.59387 6.2334 3.59387H15.7959C15.9368 3.59387 16.0719 3.64984 16.1715 3.74947C16.2712 3.8491 16.3271 3.98423 16.3271 4.12512C16.3271 4.26602 16.2712 4.40114 16.1715 4.50077C16.0719 4.6004 15.9368 4.65637 15.7959 4.65637H6.2334C6.0925 4.65637 5.95738 4.6004 5.85775 4.50077C5.75812 4.40114 5.70215 4.26602 5.70215 4.12512Z"
                                          fill="#666666"
                                        ></path>
                                      </svg>
                                    </span>
                                  </div>
                                  <div class="righteside">
                                    <span
                                      title="Edit Link"
                                      data-toggle="modal"
                                      data-target="#editlink-file"
                                    >
                                      <svg
                                        width="14"
                                        height="8"
                                        viewBox="0 0 14 8"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          d="M10.3711 7.23973H8.37109V5.90639H10.3711C10.9015 5.90639 11.4102 5.69568 11.7853 5.32061C12.1604 4.94553 12.3711 4.43683 12.3711 3.90639C12.3711 3.37596 12.1604 2.86725 11.7853 2.49218C11.4102 2.11711 10.9015 1.90639 10.3711 1.90639H8.37109V0.573059H10.3711C11.2551 0.573059 12.103 0.924249 12.7281 1.54937C13.3532 2.17449 13.7044 3.02234 13.7044 3.90639C13.7044 4.79045 13.3532 5.63829 12.7281 6.26341C12.103 6.88854 11.2551 7.23973 10.3711 7.23973ZM5.70443 7.23973H3.70443C2.82037 7.23973 1.97253 6.88854 1.3474 6.26341C0.722283 5.63829 0.371094 4.79045 0.371094 3.90639C0.371094 3.02234 0.722283 2.17449 1.3474 1.54937C1.97253 0.924249 2.82037 0.573059 3.70443 0.573059H5.70443V1.90639H3.70443C3.17399 1.90639 2.66529 2.11711 2.29021 2.49218C1.91514 2.86725 1.70443 3.37596 1.70443 3.90639C1.70443 4.43683 1.91514 4.94553 2.29021 5.32061C2.66529 5.69568 3.17399 5.90639 3.70443 5.90639H5.70443V7.23973ZM10.3711 4.57306H3.70443V3.23973H10.3711V4.57306Z"
                                          fill="#666666"
                                        ></path>
                                      </svg>
                                    </span>
                                    <span
                                      class="border-left"
                                      title="Upload you file"
                                      data-toggle="modal"
                                      data-target="#up-ur-file"
                                    >
                                      <svg
                                        width="18"
                                        height="18"
                                        viewBox="0 0 18 18"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          d="M7.88932 14.809C6.97385 14.8312 6.08693 14.4895 5.42302 13.8588C4.75911 13.2281 4.37239 12.3598 4.34766 11.4444V5.44131C4.36468 4.77955 4.64318 4.15149 5.1222 3.6946C5.60122 3.2377 6.24174 2.98919 6.90356 3.00346C7.56639 2.98761 8.20843 3.23541 8.68873 3.69247C9.16904 4.14954 9.44835 4.77851 9.46536 5.44131V11.4503C9.44082 11.8509 9.2644 12.227 8.97208 12.5019C8.67977 12.7769 8.29358 12.93 7.89227 12.93C7.49097 12.93 7.10478 12.7769 6.81247 12.5019C6.52015 12.227 6.34373 11.8509 6.31918 11.4503V5.90763C6.31918 5.75108 6.38137 5.60094 6.49207 5.49024C6.60277 5.37954 6.75291 5.31735 6.90946 5.31735C7.06601 5.31735 7.21615 5.37954 7.32685 5.49024C7.43755 5.60094 7.49974 5.75108 7.49974 5.90763V11.4503C7.51151 11.5462 7.55792 11.6344 7.63023 11.6983C7.70253 11.7623 7.79574 11.7976 7.89227 11.7976C7.98881 11.7976 8.08202 11.7623 8.15432 11.6983C8.22663 11.6344 8.27304 11.5462 8.28481 11.4503V5.44131C8.26646 5.09211 8.11113 4.76423 7.85253 4.52884C7.59394 4.29346 7.25294 4.16955 6.90356 4.18402C6.55517 4.17114 6.21569 4.29576 5.95838 4.53098C5.70107 4.76621 5.54657 5.09317 5.52821 5.44131V11.4444C5.55278 12.0468 5.81507 12.6148 6.25761 13.0242C6.70016 13.4335 7.2869 13.6508 7.88932 13.6285C8.49175 13.6508 9.07849 13.4335 9.52103 13.0242C9.96358 12.6148 10.2259 12.0468 10.2504 11.4444V5.44131C10.2504 5.28476 10.3126 5.13462 10.4233 5.02392C10.534 4.91322 10.6842 4.85103 10.8407 4.85103C10.9973 4.85103 11.1474 4.91322 11.2581 5.02392C11.3688 5.13462 11.431 5.28476 11.431 5.44131V11.4444C11.4063 12.3598 11.0195 13.2281 10.3556 13.8588C9.69172 14.4895 8.80479 14.8312 7.88932 14.809Z"
                                          fill="#666666"
                                        ></path>
                                      </svg>
                                    </span>
                                  </div>
                                </div>
                                <div class="note-btngrp">
                                  <button class="save-btn">Add Note</button>
                                </div>
                              </form>
                              <div class="note-content-area">
                                <div class="single-content">
                                  <div class="noimg-box">A</div>
                                  <div class="item-area">
                                    <div class="title-area">
                                      <h5>
                                        <a href="#">Aditya Kumar Nayak</a>
                                      </h5>
                                      <div
                                        class="editNote"
                                        title="Upload you file"
                                        data-toggle="modal"
                                        data-target="#edit-note"
                                      >
                                        <svg
                                          width="14"
                                          height="15"
                                          viewBox="0 0 14 15"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path
                                            d="M10.7974 1.36955C10.9725 1.19445 11.1803 1.05556 11.4091 0.960795C11.6379 0.866034 11.8831 0.817261 12.1307 0.817261C12.3783 0.817261 12.6235 0.866034 12.8523 0.960795C13.0811 1.05556 13.2889 1.19445 13.464 1.36955C13.6391 1.54464 13.778 1.75251 13.8728 1.98128C13.9675 2.21006 14.0163 2.45526 14.0163 2.70288C14.0163 2.9505 13.9675 3.1957 13.8728 3.42447C13.778 3.65325 13.6391 3.86112 13.464 4.03621L4.46403 13.0362L0.797363 14.0362L1.79736 10.3695L10.7974 1.36955Z"
                                            stroke="#666666"
                                            stroke-width="1.33"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                          ></path>
                                        </svg>
                                      </div>
                                    </div>
                                    <div class="snote">Note 163319</div>
                                    <div class="snote">
                                      8 Oct 2021 at 12:50 AM GMT+5:30A
                                    </div>
                                    <div class="text-area">
                                      I have talked to the candidate, he needs
                                      1-2 days to decide. Please think wheather
                                      we need an another round.
                                    </div>
                                  </div>
                                </div>
                                <div class="single-content">
                                  <div class="img-box">
                                    <img src="./image/6.png" />
                                  </div>
                                  <div class="item-area">
                                    <div class="title-area">
                                      <h5>
                                        <a href="#">Sailini Subushi</a>
                                      </h5>
                                      <div
                                        class="editNote"
                                        title="Upload you file"
                                        data-toggle="modal"
                                        data-target="#edit-note"
                                      >
                                        <svg
                                          width="14"
                                          height="15"
                                          viewBox="0 0 14 15"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path
                                            d="M10.7974 1.36955C10.9725 1.19445 11.1803 1.05556 11.4091 0.960795C11.6379 0.866034 11.8831 0.817261 12.1307 0.817261C12.3783 0.817261 12.6235 0.866034 12.8523 0.960795C13.0811 1.05556 13.2889 1.19445 13.464 1.36955C13.6391 1.54464 13.778 1.75251 13.8728 1.98128C13.9675 2.21006 14.0163 2.45526 14.0163 2.70288C14.0163 2.9505 13.9675 3.1957 13.8728 3.42447C13.778 3.65325 13.6391 3.86112 13.464 4.03621L4.46403 13.0362L0.797363 14.0362L1.79736 10.3695L10.7974 1.36955Z"
                                            stroke="#666666"
                                            stroke-width="1.33"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                          ></path>
                                        </svg>
                                      </div>
                                    </div>
                                    <div class="snote">Note 163319</div>
                                    <div class="snote">
                                      8 Oct 2021 at 12:50 AM GMT+5:30A
                                    </div>
                                    <div class="text-area">
                                      Are we still providing 24 “monitors”? I
                                      thought we only provided laptops
                                    </div>
                                  </div>
                                </div>
                                <div class="single-content">
                                  <div class="img-box">
                                    <img src="./image/4.png" />
                                  </div>
                                  <div class="item-area">
                                    <div class="title-area">
                                      <h5>
                                        <a href="#">Tanmaya Biswal</a>
                                      </h5>
                                      <div
                                        class="editNote"
                                        title="Upload you file"
                                        data-toggle="modal"
                                        data-target="#edit-note"
                                      >
                                        <svg
                                          width="14"
                                          height="15"
                                          viewBox="0 0 14 15"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path
                                            d="M10.7974 1.36955C10.9725 1.19445 11.1803 1.05556 11.4091 0.960795C11.6379 0.866034 11.8831 0.817261 12.1307 0.817261C12.3783 0.817261 12.6235 0.866034 12.8523 0.960795C13.0811 1.05556 13.2889 1.19445 13.464 1.36955C13.6391 1.54464 13.778 1.75251 13.8728 1.98128C13.9675 2.21006 14.0163 2.45526 14.0163 2.70288C14.0163 2.9505 13.9675 3.1957 13.8728 3.42447C13.778 3.65325 13.6391 3.86112 13.464 4.03621L4.46403 13.0362L0.797363 14.0362L1.79736 10.3695L10.7974 1.36955Z"
                                            stroke="#666666"
                                            stroke-width="1.33"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                          ></path>
                                        </svg>
                                      </div>
                                    </div>
                                    <div class="snote">Note 163319</div>
                                    <div class="snote">
                                      8 Oct 2021 at 12:50 AM GMT+5:30A
                                    </div>
                                    <div class="text-area">
                                      Hey, I've been thinking about to using
                                      your software for a while.
                                    </div>
                                  </div>
                                </div>
                                <div class="single-content">
                                  <div class="img-box">
                                    <img src="./image/5.png" />
                                  </div>
                                  <div class="item-area">
                                    <div class="title-area">
                                      <h5>
                                        <a href="#">Ratikanta Sahoo</a>
                                      </h5>
                                      <div
                                        class="editNote"
                                        title="Upload you file"
                                        data-toggle="modal"
                                        data-target="#edit-note"
                                      >
                                        <svg
                                          width="14"
                                          height="15"
                                          viewBox="0 0 14 15"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path
                                            d="M10.7974 1.36955C10.9725 1.19445 11.1803 1.05556 11.4091 0.960795C11.6379 0.866034 11.8831 0.817261 12.1307 0.817261C12.3783 0.817261 12.6235 0.866034 12.8523 0.960795C13.0811 1.05556 13.2889 1.19445 13.464 1.36955C13.6391 1.54464 13.778 1.75251 13.8728 1.98128C13.9675 2.21006 14.0163 2.45526 14.0163 2.70288C14.0163 2.9505 13.9675 3.1957 13.8728 3.42447C13.778 3.65325 13.6391 3.86112 13.464 4.03621L4.46403 13.0362L0.797363 14.0362L1.79736 10.3695L10.7974 1.36955Z"
                                            stroke="#666666"
                                            stroke-width="1.33"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                          ></path>
                                        </svg>
                                      </div>
                                    </div>
                                    <div class="snote">Note 163319</div>
                                    <div class="snote">
                                      8 Oct 2021 at 12:50 AM GMT+5:30A
                                    </div>
                                    <div class="text-area">
                                      Lorem ipsum dolor sit amet, consect etur
                                      adipiscing elit, sed do eiusmod tempor
                                      incididunt ut labore et dolore magna
                                      aliqua.
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="tab-pane" id="history">
                            <div class="history-viewarea">
                              <div class="single-history">
                                <label>2nd Nov, 2022 12:05:41</label>
                                <h6>Uma Shankar Sahu</h6>
                                <p>
                                  <span>-</span> Note Updated : 214693
                                </p>
                                <a href="#">
                                  <span>-</span> View Revision
                                </a>
                              </div>
                              <div class="single-history">
                                <label>2nd Nov, 2022 12:05:41</label>
                                <h6>Pulak Dash</h6>
                                <p>
                                  <span>-</span> Note Added : 214619
                                </p>
                                <a href="#">
                                  <span>-</span> View Revision
                                </a>
                              </div>
                              <div class="single-history">
                                <label>1st Nov, 2022 12:22:22</label>
                                <h6>Niharika Mishra</h6>
                                <p>
                                  <span>-</span> End Date Updated
                                </p>
                                <p>
                                  <span>-</span> 01-11-2022
                                </p>
                              </div>
                              <div class="single-history">
                                <label>1st Nov, 2022 12:21:35</label>
                                <h6>Niharika Mishra</h6>
                                <p>
                                  <span>-</span> Start Date Updated
                                </p>
                                <p>
                                  <span>-</span> 01-11-2022
                                </p>
                              </div>
                              <div class="single-history">
                                <label>1st Nov, 2022 10:19:38</label>
                                <h6>Manswini Rout</h6>
                                <p>
                                  <span>-</span> Go - Live Updated
                                </p>
                                <p>
                                  <span>-</span> 04-01-2022
                                </p>
                              </div>
                              <div class="single-history">
                                <label>2nd Nov, 2022 12:05:41</label>
                                <h6>Uma Shankar Sahu</h6>
                                <p>
                                  <span>-</span> Note Updated : 214693
                                </p>
                                <a href="#">
                                  <span>-</span> View Revision
                                </a>
                              </div>
                              <div class="single-history">
                                <label>1st Nov, 2022 10:19:38</label>
                                <h6>Manswini Rout</h6>
                                <p>
                                  <span>-</span> Go - Live Updated
                                </p>
                                <p>
                                  <span>-</span> 04-01-2022
                                </p>
                              </div>
                              <div class="single-history">
                                <label>1st Nov, 2022 10:19:38</label>
                                <h6>Manswini Rout</h6>
                                <p>
                                  <span>-</span> Go - Live Updated
                                </p>
                                <p>
                                  <span>-</span> 04-01-2022
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </React.Fragment>
  );
};

export default ChatDetailsCommon;



// WEBPACK FOOTER //
// ./src/components/chat/ChatDetailsCommon.js